import React, { useEffect, useState, useContext, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { clearCache } from './CacheHandler';
import { ModeContext } from './ModeContext';

// チェック間隔（ミリ秒）：本番は 5 * 60 * 1000 に戻す
const CHECK_INTERVAL = 10 * 1000;
// localStorageに保存するキー
const VERSION_KEY = 'app_version';

const VersionChecker = () => {
  const [open, setOpen] = useState(false);
  const { setLoginInfo, setSessionId } = useContext(ModeContext);
  const navigate = useNavigate();

  useEffect(() => {
    // バージョンチェック処理
    const checkVersion = async () => {
      try {
        // キャッシュを完全に回避してmeta.jsonを取得
        const res = await fetch('/meta.json', {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' }
        });
        if (!res.ok) {
          //console.warn('[VersionChecker] meta.json取得失敗:', res.status);
          return;
        }
        const meta = await res.json();
        const savedVersion = localStorage.getItem(VERSION_KEY);
        //console.log('[VersionChecker] 取得バージョン:', meta.version, '/ 保存バージョン:', savedVersion);

        // 初回（localStorageに未保存）はバージョンを記録するだけ
        if (!savedVersion) {
          localStorage.setItem(VERSION_KEY, meta.version);
          //console.log('[VersionChecker] 初回バージョン記録:', meta.version);
          return;
        }

        // バージョンが変わっていたらダイアログ表示
        if (meta.version !== savedVersion) {
          //console.log('[VersionChecker] バージョン不一致を検知。ダイアログ表示');
          setOpen(true);
        }
      } catch (err) {
        console.error('[VersionChecker] バージョンチェックに失敗しました:', err);
      }
    };

    console.log('[VersionChecker] コンポーネントがマウントされました');

    // 初回チェック
    checkVersion();

    // 定期チェック
    const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(intervalId);
  }, []);

  // ログアウトしてログインページへ遷移
  const handleLogoutAndReload = () => {
    // 新しいバージョンをlocalStorageに記録してからログアウト
    fetch('/meta.json', { cache: 'no-store' })
      .then(res => res.json())
      .then(meta => localStorage.setItem(VERSION_KEY, meta.version))
      .catch(() => {})
      .finally(() => {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('customerId');
        localStorage.removeItem('username');
        localStorage.removeItem('authorityId');
        localStorage.removeItem('prompt');
        localStorage.removeItem('webhook');
        localStorage.removeItem('compId');
        localStorage.removeItem('compName');
        localStorage.removeItem('data');
        localStorage.removeItem('faqapi');
        localStorage.removeItem('id');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');

        setSessionId('');
        clearCache();
        setLoginInfo({ isLoggedIn: false });

        // ブラウザキャッシュを完全にクリアして再読み込み
        window.location.href = '/login';
      });
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      aria-labelledby="version-update-dialog-title"
      aria-describedby="version-update-dialog-description"
      slotProps={{
        backdrop: {
          onClick: (e) => e.stopPropagation()
        }
      }}
    >
      <DialogTitle id="version-update-dialog-title">
        アプリが更新されました
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="version-update-dialog-description">
          新しいバージョンが利用可能です。最新の機能をご利用いただくため、再ログインしてください。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleLogoutAndReload}
          variant="contained"
          color="primary"
          autoFocus
        >
          再ログインする
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionChecker;
